var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 13.7502C28.7657 13.7502 29.7917 14.7762 29.7917 16.0418V29.7918C29.7917 31.0575 28.7657 32.0835 27.5 32.0835C26.2344 32.0835 25.2084 31.0575 25.2084 29.7918V16.0418C25.2084 14.7762 26.2344 13.7502 27.5 13.7502Z",
    fill: "#1A3D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 36.6668C26.2344 36.6668 25.2084 37.6928 25.2084 38.9585C25.2084 40.2241 26.2344 41.2502 27.5 41.2502C28.7657 41.2502 29.7917 40.2241 29.7917 38.9585C29.7917 37.6928 28.7657 36.6668 27.5 36.6668Z",
    fill: "#1A3D82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 4.5835C14.8435 4.5835 4.58337 14.8436 4.58337 27.5002C4.58337 40.1567 14.8435 50.4168 27.5 50.4168C40.1566 50.4168 50.4167 40.1567 50.4167 27.5002C50.4167 14.8436 40.1566 4.5835 27.5 4.5835ZM9.16671 27.5002C9.16671 37.6254 17.3748 45.8335 27.5 45.8335C37.6253 45.8335 45.8334 37.6254 45.8334 27.5002C45.8334 17.3749 37.6253 9.16683 27.5 9.16683C17.3748 9.16683 9.16671 17.3749 9.16671 27.5002Z",
    fill: "#1A3D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.8c4970e1694d7e7bc8a70a18f472ec81.svg";
export { ForwardRef as ReactComponent };